import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { WEB_COMPONENT_MDR_CUSTOMER_PANEL } from '../../../webcomponents.constants';
import { ButtonColors } from '../../../ui/gzButton/types';

export const templateMdrCompaniesGrid = document.createElement('template');

templateMdrCompaniesGrid.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <header class="page__header">
      <gz-title id='page-title' fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
    </header>
    <div class='grid-wrapper'>
      <gz-grid-view class='grid-view' showGlobalActions>
          <div slot='grid-header-infobox-slot'>
              <gz-info-box severity='warning' class='mb-2 hidden' id='sso-disabled'></gz-info-box>
          </div>
          <div slot='grid-header-actions-slot' class='header__actions'>
            <gz-button id='open-console-button' class='action-button hidden' type='full' color='${ButtonColors.PRIMARY}'></gz-button>
          </div>
      </gz-grid-view>
    </div>

    <div class='customer-wrapper'>
      <${WEB_COMPONENT_MDR_CUSTOMER_PANEL} />
    </div>
  </div>
`;
